import React, { FC } from 'react';
import {
  Container,
  Content,
  WarningIcon,
  Text,
  WrapperButton,
  Button,
} from './styles';
import { Props } from './types';

const Modal: FC<Props> = ({ message, open, onClose, onYes, onNo }) => {
  return (
    <Container open={open} handleClose={onClose}>
      <Content>
        <WarningIcon />
        <Text>{message}</Text>
        <WrapperButton>
          <Button type="button" color="primary" onClick={onYes}>
            Apply to all
          </Button>
          <Button variant="outlined" color="secondary" onClick={onNo}>
            Selected only
          </Button>
        </WrapperButton>
      </Content>
    </Container>
  );
};

export default Modal;

// TODO: TFR-29 add story to component
